<template>
  <div class="d-inline-block position-relative" @click.stop>
      <div v-if="editMode">
        <form @submit.prevent="save">
          <div class="input-group input-group-sm">
            <input type="text" v-model="myValue" class="form-control" ref="inputRef" @blur="handleBlur">
            <button type="button" @click="cancel" class="btn btn-outline-danger" title="Cancel"><i class="bi bi-ban"></i></button>
            <button type="submit" class="btn btn-outline-success" title="Save"><i class="bi bi-check"></i></button>
          </div>
        </form>
      </div>
      <div v-else @click="edit" style="cursor: pointer">
        <slot></slot>{{ currentValue }}
        <small><sup><i class="bi bi-pencil"></i></sup></small>
      </div>
  </div>
</template>

<script setup>
import {defineProps, ref, toRef, defineEmits, watch, nextTick, onBeforeUnmount} from "vue";
const props = defineProps(['currentValue'])
const editMode = ref(false)
const inputRef = ref(null)
const myValue = ref(props.currentValue)
const propRef = toRef(props, 'currentValue')
const emits = defineEmits(['onSave'])
const shouldCancel = ref(false)

async function edit() {
  myValue.value = props.currentValue
  editMode.value = true
  shouldCancel.value = false
  await nextTick()
  await new Promise(resolve => setTimeout(resolve, 500))
  if (inputRef.value) {
    inputRef.value.focus()
    inputRef.value.select()
  }
  window.addEventListener('keydown', listeners)
  document.body.addEventListener('click', listeners)
}
function save() {
  emits('onSave', myValue.value)
  clear()
}
function cancel() {
  shouldCancel.value = true
  clear()
}
function clear() {
  editMode.value = false
  window.removeEventListener('keydown', listeners)
  document.body.removeEventListener('click', listeners)
}
function handleBlur() {
  // Small delay to allow cancel button click to set shouldCancel flag
  setTimeout(() => {
    if (!shouldCancel.value && editMode.value) {
      save()
    }
    shouldCancel.value = false
  }, 150)
}
function listeners(e) {
  if (e.keyCode === 27) {
    shouldCancel.value = true
    clear()
  }
  // Don't handle clicks here - let blur handle saving
  // Click listener will be removed by clear() after blur completes
}
watch(propRef, (newValue) => {
  if (newValue) {
    myValue.value = newValue
  }
})
onBeforeUnmount(() => {
  clear()
})
</script>
